import { RegisterationText } from "texts/registerationText";
import { ArrowLeftIconOutline, InfoCircleIcon } from "../icons";
import { Button } from "antd";
import { useCreateVendor } from "api/registration/RegistrationHookReq";
import useNotification from "hooks/useNotification";

interface Props {
  value: any;
  handleChangeStep: (step: number) => void;
}
const RegisterStep6 = ({ value, handleChangeStep }: Props) => {
  const data = [
    { title: RegisterationText?.pharmacyName, value: value?.vendorName },
    { title: RegisterationText?.pharmacyManagerName, value: value?.name },
    { title: RegisterationText?.pharmacyTechnicalAssistant, value: value?.technicalAssistantName },
    { title: RegisterationText?.pharmacyManagerMobileNumber, value: value?.phoneNumber },
    { title: RegisterationText?.pharmacyPhoneNumber, value: value?.contactNumber },
    { title: RegisterationText?.pharmacyAddress, value: value?.address },
  ];
  const { mutate: mutateCreateVendor, isLoading: createVendorLoading } = useCreateVendor();
  const { openNotification } = useNotification();

  const handleRegisterVendor = () => {
    mutateCreateVendor(value, {
      onSuccess: () => {
        handleChangeStep(7);
      },
      onError: (error: any) => {
        openNotification({
          message: "خطایی رخ داده است",
          type: "error",
        });
      },
    });
  };

  return (
    <div className="w-full">
      <h2 className="text-center text-xl font-medium mb-4">{RegisterationText?.confirmInfo}</h2>
      <div className="w-[calc(100%+32px)] -mx-4 mb-6">
        {data?.map((item, index) => {
          return (
            <div className="text-sm odd:bg-grey-100 py-2 px-4" key={index}>
              <span className="font-bold">{item?.title}</span> : <span>{item?.value}</span>
            </div>
          );
        })}
      </div>
      <div className="w-[calc(100%+32px)] -mx-4 px-4 bg-red-50 py-4 flex gap-x-1 font-normal text-sm">
        <div className="w-6">
          <InfoCircleIcon width={24} height={24} stroke="#FF6136" />
        </div>
        <div className="w-calc(100%-24px)">{RegisterationText?.confirmInfoTime}</div>
      </div>
      <div className="flex mt-6 gap-x-4">
        <Button type="text" className="bg-white flex justify-center items-center gap-x-1 border border-black text-black w-full" onClick={(e) => handleChangeStep(1)} size="large">
          {RegisterationText?.editInfo}
          <ArrowLeftIconOutline width={24} height={24} stroke="black" />
        </Button>
        <Button type="text" className="bg-black flex justify-center items-center gap-x-1 border border-black text-white w-full" onClick={(e) => handleRegisterVendor()} size="large">
          {RegisterationText?.confirmAndRegister}
          <ArrowLeftIconOutline width={24} height={24} stroke="white" />
        </Button>
      </div>
    </div>
  );
};
export default RegisterStep6;
